import React from "react";
import ReactEcharts from "echarts-for-react";

function LineData() {
  const getOptions = () => {
    return {
      grid: {
        left: 20, // 左边距20px
        right: 20, // 右边距20px
        bottom: 20,
        top: 60,
        containLabel: true,
      },
      xAxis: {
        type: "category",
        data: [2023, 2024, 2025, 2026],
      },
      yAxis: {
        type: "value",
        splitLine: {
          show: true, // 默认一般就是显示的，可以不写
          lineStyle: {
            type: "dashed", // 设置为虚线
            color: "#ccc", // 网格线颜色，可自定义
            width: 1,
          },
        },
      },
      legend: { data: ["男", "女"], top: 10 },
      series: [
        {
          name: "男",
          data: [1200, 1400, 1300, 1500],
          type: "line",
          smooth: true,
          lineStyle: {
            color: "#2094ff", // 折线颜色，比如红色
            width: 2, // 折线宽度，可选
          },
          symbol: "circle", // 折点形状（circle=圆形，还可设为rect=矩形、triangle=三角形等）
          symbolSize: 8, // 折点大小（数值越大，折点越大）
          symbolColor: "#ff4500", // 折点填充色（橙色，醒目）
          symbolStrokeColor: "#fff", // 折点边框色（白色）
          symbolStrokeWidth: 2, // 折点边框宽度（增强对比）
          // 可选：鼠标悬浮时折点放大，提升交互体验
          emphasis: {
            symbolSize: 12, // 悬浮时折点放大到12px
          },
        },
        {
          name: "女",
          data: [1000, 1150, 1107, 1301],
          type: "line",
          smooth: true,
          lineStyle: {
            color: "#2094ff", // 折线颜色，比如红色
            width: 2, // 折线宽度，可选
          },
          symbol: "circle", // 折点形状（circle=圆形，还可设为rect=矩形、triangle=三角形等）
          symbolSize: 8, // 折点大小（数值越大，折点越大）
          symbolColor: "#ff4500", // 折点填充色（橙色，醒目）
          symbolStrokeColor: "#fff", // 折点边框色（白色）
          symbolStrokeWidth: 2, // 折点边框宽度（增强对比）
          // 可选：鼠标悬浮时折点放大，提升交互体验
          emphasis: {
            symbolSize: 12, // 悬浮时折点放大到12px
          },
        },
      ],
    };
  };

  return (
    <>
      <ReactEcharts
        style={{
          minHeight: "300px",
          width: "100%",
        }}
        option={getOptions()}
      />
    </>
  );
}

export default LineData;
